import "./NewsBanner.scss";
import {
  FormattedMessage,
  // , useIntl
} from "react-intl";
import ChevronIcon from "svg-icons/chevron-icon";
import useSWR from "swr";
import { END_POINTS } from "constants/APIConstant";
import ContentLoading from "component/LoadingComponent/ContentLoading";
import LabelLang, { LabelLangString } from "component/LabelLang/label-lang";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import HtmlView from "component/htmlView/html-view";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import { API_BASE_URL } from "configs/AppConfig";

function NewsBanner() {
  // const intl = useIntl();

  const currentLocale = useSelector(({ theme }) => theme.locale);

  const getData = useSWR({
    url: END_POINTS.HAPPENING_NOW,
  });

  const header = <FormattedMessage id="happening-now" />;
  const details = <FormattedMessage id="more-details" />; //"Details"

  return (
    <ContentLoading isLoading={getData.isLoading}>
      <div className="grid-container news-banner">
        <div className="col-12">
          {!getData.isLoading && !getData.error && getData?.data?.data[0] ? (
            <div className="row">
              <div className="col-xl-6 col-lg-12 col-md-6 col-12">
                <div
                  className="fixed-height"
                  style={{
                    maxHeight: "325px",
                    overflowY: "auto",
                    paddingInlineEnd: "0.5rem",
                  }}
                >
                  <h4 className="news-banner-main-title mb-3">{header}:</h4>
                  <h4 className="news-banner-title">
                    <LabelLang
                      id="title"
                      defaultValue={getData?.data?.data[0]?.title}
                      translations={
                        getData?.data?.data[0]?.happeningNowTranslations
                      }
                    />
                  </h4>
                  <hr
                    style={{
                      borderWidth: "3px",
                      color: "white",
                      width: "80%",
                      opacity: "100%",
                    }}
                  ></hr>
                  <p className="news-banner-sub">
                    <HtmlView
                      html={LabelLangString({
                        id: "content",
                        currentLocale: currentLocale,
                        defaultValue: getData?.data?.data[0]?.content,
                        translations:
                          getData?.data?.data[0]?.happeningNowTranslations,
                      })}
                    />
                  </p>
                </div>
              </div>

              <div className="col-xl-6 col-lg-12 col-md-6 col-12">
                {getData?.data?.data[0]?.mediaUrl && (
                  <div className="row-r mt-2">
                    {getData?.data?.data[0]?.mediaUrl?.includes("http") ? (
                      <iframe
                        src={getData?.data?.data[0]?.mediaUrl}
                        style={{ borderRadius: "20px" }}
                        height={250}
                        width={"100%"}
                      />
                    ) : (
                      <img
                        className="w-100"
                        style={{ borderRadius: "20px" }}
                        loading="lazy"
                        src={`${API_BASE_URL}/${getData?.data?.data[0]?.mediaUrl}`}
                        alt={"Happening Now Image"}
                      />
                    )}
                  </div>
                )}
                {getData?.data?.data[0]?.link && (
                  <div
                    className="row-r"
                    style={{
                      marginTop: getData?.data?.data[0]?.mediaUrl
                        ? "30px"
                        : "200px",
                    }}
                  >
                    <div className="brwn">
                      {getData?.data?.data[0]?.isInternal &&
                      !getData?.data?.data[0]?.link.includes("http") ? (
                        <Link
                          to={`/${getData?.data?.data[0]?.link}`}
                          className="white-btn"
                        >
                          <span className="px-2">{details}</span>
                          <ChevronIcon
                            width={12}
                            height={12}
                            color="var(--main-color)"
                          />
                        </Link>
                      ) : (
                        <a
                          href={getData?.data?.data[0]?.link}
                          target="_blank"
                          className="white-btn"
                        >
                          <span>{details}</span>
                          <ChevronIcon
                            width={12}
                            height={12}
                            color="var(--main-color)"
                          />
                        </a>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <DataNotFound color="text-white" />
          )}
        </div>
      </div>
    </ContentLoading>
  );
}

export default NewsBanner;
